import cx from "classnames";
import * as React from "react";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className, ...props }: CardProps) {
  return (
    <div
      className={cx("rounded-md bg-gray-100 p-6 shadow-md", className)}
      {...props}
    >
      {children}
    </div>
  );
}
